import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../context/AppContext";
import { ReportService } from "../../../services/ReportsService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { AlertService } from "../../../services/Alert";

export default function ContactInfo({ initialsCustomer, ticket, customer }) {
  const { t } = useTranslation();
  const { account } = useCurrentAccount();
  const { setShowCustomerDetail } = useContext(AppContext);
  const [logsInfo, setLogsInfo] = useState(null);
  const getLogsDetail = async () => {
    if (ticket.id && account.id) {
      const { data } = await ReportService.getLogsTickets(
        account.id,
        ticket.id
      );
      setLogsInfo(data);
    } else {
      setLogsInfo(null);
    }
  };

  useEffect(() => {
    getLogsDetail();
  }, []);

  return (
    <div className="col-3  border ">
      <div className="text-center h-100 overflow-scroll sidebar">
        <div className="pt-5 bg-white ticket-info-header border-bottom">
          <div>
            <span className="avatar avatar-xl avatar-primary avatar-circle">
              <span className="avatar-initials">{initialsCustomer}</span>
            </span>
          </div>
          <h3 className="mt-3">{ticket?.name_client}</h3>
          <p className="form-text m-0">
            <i className="bi-telephone me-1"></i>{" "}
            {ticket?.chat_number?.slice(0, -5)}
          </p>
          <div className="d-flex justify-content-center my-5">
            {/* <div>
                            <button className="btn bg-soft-primary icon icon-circle mb-2 " >
                                {customer?.blocked ? <i className="bi-unlock"></i> : <i className="bi-lock"></i> }
                            </button>
                            <p className="form-text m-0">{customer?.blocked ? t('follow-up.tickets.conversation.unblock-btn') : t('follow-up.tickets.conversation.block-btn')}</p>
                        </div> */}
            <div>
              <button
                className="btn bg-soft-primary icon icon-circle mb-2"
                onClick={() =>
                  setShowCustomerDetail({
                    account_client_id: ticket.account_key_client,
                    show: true,
                  })
                }
              >
                <i className="bi-pencil"></i>
              </button>
              <p className="form-text m-0">{t("btn-edit")}</p>
            </div>
          </div>
        </div>
        <div className={`${customer?.commets?.length > 0 && 'm-3' } text-start`}>
          {customer?.commets?.length > 0 && (
            <>
              <p className="card-subtitle ">Comentarios de seguimiento</p>

              {customer.commets.map((c, index) => (
                <div
                  className={`mt-3 ${
                    index < customer.commets.length - 1 ? "border-bottom" : ""
                  }`}
                  key={index}
                >
                  <div className="flex-grow-1 ">
                    <div>
                      <h5 className="mbottom-6">{c.tag}</h5>
                    </div>
                    <p className="m-0 p-0">{c.commet}</p>
                    <p className="mt-2 mbottom-6">{c.username}</p>
                    <p className="small">{c.date}</p>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
        <div className="mt-2">
          {Array.isArray(logsInfo) && logsInfo.length > 0 ? (
            <div>
              <h5>Historial del Ticket</h5>
              <div
                className="logs-container mx-h-300px scroll-y"
              >
                {logsInfo.map((log, index) => (
                  <div
                    key={index}
                    className={`${index < logsInfo.length - 1 ? "border-bottom py-2" : ""
                      }`}
                  >
                    <p className="m-0 p-0"> <strong>Fecha:</strong> {log.date.split(" ")[0]} </p>
                    <p className="m-0 p-0"> <strong>Hora:</strong> {log.date.split(" ")[1]} </p>
                    <p className="m-0 p-0">
                      <strong>Descripción:</strong>
                      <br /> 
                      {log.log_text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
              <div className="bg-soft-info-alternative h-350 d-flex justify-content-center align-items-center">
                <div className="text-center p-4">
                  <i className="bi bi-exclamation-circle-fill fs-2 text-muted"></i>
                  <p className="text-white-dark">Este ticket no contiene historial</p>
                </div>
              </div>
          )}
        </div>
      </div>
    </div>
  );
}
